export enum Sentiment {
  NEGATIVE = 'negative',
  NEUTRAL = 'neutral',
  POSITIVE = 'positive',
  WARNING = 'warning',
  // remove when all instances of Sentiment.PENDING have been updated to Status.PENDING
  PENDING = 'pending',

  /**
   * @deprecated
   */
  INFO = 'info',
  /**
   * @deprecated
   */
  ERROR = 'error',
  /**
   * @deprecated
   */
  SUCCESS = 'success',
}
